import React from 'react';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      <h1>Welcome to PROCO Co.</h1>
      <p>Proud member of the greater DC/MD/VA Metropolitan community and<br/> we've enjoyed serving you since 1999.</p>
      <button onClick={() => window.location.href = '/schedule-pickup'}>Schedule a Pickup</button>
    </div>
  );
};

export default Home;
